import ROUTES from '~/shared/constants/routes.const'
import { IconName } from '~/components/Icons'
import { STUDENT_PANEL_VIEW } from '~/types/student'

export const STUDENT_PANEL_TABS: Array<{ href: string; icon: IconName; type: STUDENT_PANEL_VIEW }> = [
  // TODO: Temporarly disable.
  // {
  //   href: ROUTES.STUDENT_PANEL_OBSERVER,
  //   icon: 'hom-binoculars',
  //   type: STUDENT_PANEL_VIEW.OBSERVER,
  // },
  {
    href: ROUTES.STUDENT_PANEL_APPOINTMENTS,
    icon: 'hom-calendar',
    type: STUDENT_PANEL_VIEW.APPOINTMENTS,
  },
  {
    href: ROUTES.STUDENT_PANEL_MY_TUTOR,
    icon: 'hom-classroom-alt',
    type: STUDENT_PANEL_VIEW.MY_TUTOR,
  },
  {
    href: ROUTES.STUDENT_PANEL_RECEIPTS,
    icon: 'hom-receipt',
    type: STUDENT_PANEL_VIEW.RECEIPTS,
  },
  {
    href: ROUTES.STUDENT_PANEL_SETTINGS,
    icon: 'hom-settings',
    type: STUDENT_PANEL_VIEW.SETTINGS,
  },
]
